import { render } from "./ConfidentialReportChannelWidget.vue?vue&type=template&id=28f740f7&scoped=true"
import script from "./ConfidentialReportChannelWidget.vue?vue&type=script&lang=js"
export * from "./ConfidentialReportChannelWidget.vue?vue&type=script&lang=js"

import "./ConfidentialReportChannelWidget.vue?vue&type=style&index=0&id=28f740f7&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\52618\\Documentos\\TheGoodMark\\Sistemas\\RHTGM\\orangehrm-5.9\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28f740f7"]])

export default __exports__